var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricIconResponse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#FFF3E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#FFF9F2",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22866_22373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2828 26.4117H25.8618C27.9598 26.4117 29.1389 24.1686 27.3928 23.0056C26.6919 22.5389 25.9282 22.1593 25.1169 21.8822",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3655 18.9717C21.7292 19.0673 22.1331 19.1162 22.5749 19.1162C24.8222 19.1162 26.0864 17.852 26.0864 15.6047C26.0864 13.3573 24.8222 12.0932 22.5749 12.0932C22.5487 12.0932 22.5227 12.0933 22.4968 12.0937",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4393 22.7209C24.3315 23.9812 23.0538 26.4118 20.7803 26.4118H12.2426C9.9691 26.4118 8.69138 23.9812 10.5836 22.7209C12.2809 21.5904 14.3192 20.9316 16.5114 20.9316C18.7036 20.9316 20.742 21.5904 22.4393 22.7209Z",
    fill: "#F3E1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5143 18.4313C18.99 18.4313 20.3826 17.0387 20.3826 14.563C20.3826 12.0872 18.99 10.6946 16.5143 10.6946C14.0385 10.6946 12.6459 12.0872 12.6459 14.563C12.6459 17.0387 14.0385 18.4313 16.5143 18.4313Z",
    fill: "#F3E1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4393 22.7209C24.3315 23.9812 23.0538 26.4118 20.7803 26.4118H12.2426C9.9691 26.4118 8.69138 23.9812 10.5836 22.7209C12.2809 21.5904 14.3192 20.9316 16.5114 20.9316C18.7036 20.9316 20.742 21.5904 22.4393 22.7209Z",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5143 18.4313C18.99 18.4313 20.3826 17.0387 20.3826 14.563C20.3826 12.0872 18.99 10.6946 16.5143 10.6946C14.0385 10.6946 12.6459 12.0872 12.6459 14.563C12.6459 17.0387 14.0385 18.4313 16.5143 18.4313Z",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22866_22373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8.95309 8.55331)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconResponse);
export default __webpack_public_path__ + "static/media/MetricIconResponse.42a0a6d16363004f9149bffa1be5e64d.svg";
export { ForwardRef as ReactComponent };